const disableClick = function($container) {
  const container = $container || $('@body');
  const $targets = container.find($('@disableClick'));
  const $targetsPresent = $targets.length > 0;
  const $modal = container.find($('#modal_message'));
  const $msgTarget = $modal.find($('@message'));

  const showMsg = (text) => {
    container.on($.modal.OPEN, (event, modal) => {
      $msgTarget.html(text);
    });
    $modal.modal();
  };

  if ($targetsPresent) {
    $targets.each(function() {
      const $this = $(this);
      $this.attr('href', 'javascript:void(0);').addClass('disabled');

      $this.on('click', (e) => {
        e.preventDefault();
        const $this = $(this);
        const $msg = $this.data('message');

        if ($msg !== '' && $msg !== undefined) {
          showMsg($msg);
        }
      });
    });
  }
};

export default disableClick;
